import { Box } from "@mui/material";
import Info from "./comps/Info";
import Table from "components/Table2";
import PriceFormat from "components/CloseFiscalYear/PriceFormat";
import { formatPrice } from "helpers";
import { useRef } from "react";
import ReactToPrint from "react-to-print";
// @ts-ignore
import Num2persian from "num2persian";
import { useAppSelector } from "store/store";

const PrintTransaction = (props: {
    data: any, table: {
        source: TableProps;
        destination: TableProps;
    },
    typeTitle: string

}) => {
    const transaction = props.data;
    const { typeTitle } = props
    const table = props.table;
    const ref = useRef(null)
    const store = useAppSelector((x: any) => x);
    const businessnickName = store.businessReducer.business.business.nickName
    const returnDestination = (type: "شخص" | "چک" | "تنخواه گردان" | "صندوق" | "بانک", data?: StringObj[]) => {
        const rows = data && data.filter((x) => x.type === type);
        if (rows?.length) {
            return (<>

                <div className=" border-black w-full">
                    <div className="w-full border-1 flex text-center  border-black justify-center">{type}</div>
                    <div className="flex flex-col  w-full border-x  border-black">
                        <div className="flex gap-4 justify-between p-3 ">
                            <span>ردیف</span>
                            <span>عنوان</span>
                            <span>شرح</span>
                            <span>مبلغ</span>
                        </div>
                        <div className="flex-col gap-2 justify-between">
                            {
                                rows.map((item, index) => {
                                    return (
                                        <div key={index} className="flex gap-4 justify-between p-3 border-black border-t">
                                            <span>{index + 1}</span>
                                            <span>{item.label}</span>
                                            <span>{item.description}</span>
                                            <span>{formatPrice(item.price)}</span>
                                        </div>
                                    )
                                })
                            }


                        </div>
                    </div>
                </div>
            </>)

        }
        return <></>
    }
    return (<>
        <div className="hidden">
            <div ref={ref} dir="rtl" className="p-4">
                <div className="flex flex-col place-content-center place-items-center gap-1">
                    <span>{businessnickName}  </span>
                    <span> {`تراکنش ${typeTitle} `}  </span>
                </div>
                <div className="flex justify-between mt-5">
                    <div className="flex gap-4">
                        <span className="font-bold">پروژه :</span>
                        <span>{transaction?.Project?.title}</span>
                    </div>
                    <div className="flex gap-4">
                        <span className="font-bold">شعبه:</span>
                        <span>{transaction?.Branch?.title}</span>
                    </div>
                    <div className="flex gap-4">
                        <span className="font-bold">شماره:</span>
                        <span>{transaction.accountingCode}</span>
                    </div>
                </div>
                <div className="flex justify-between mt-5">
                    <div className="flex gap-4">
                        <span className="font-bold">بابت :</span>
                        <span>{transaction.description}</span>
                    </div>
                    <div className="flex gap-4">
                        <span className="font-bold">تاریخ:</span>
                        <span>{transaction.date}</span>
                    </div>
                </div>
                <div className="place-items-center   pt-2  flex-col">
                    <Info
                        titleStyle={{ color: "black" }}
                        title={transaction.type === "cost" ? "پرداخت به" : transaction.type === "income" ? "دریافت از" : transaction.type === "receive" ? "دریافت از" : "پرداخت به"}
                        info={""}
                    />
                    <div className="flex-col justify-center place-content-center border-1 border-black text-center w-full">
                        {returnDestination("شخص", table.source.rows)}
                        {returnDestination("چک", table.source.rows)}
                        {returnDestination("تنخواه گردان", table.source.rows)}
                        {returnDestination("صندوق", table.source.rows)}
                        {returnDestination("بانک", table.source.rows)}
                    </div>
                    <Info

                        titleStyle={{ color: "black" }}
                        title={transaction.type === "cost" ? "مبدا پرداخت" : transaction.type === "income" ? "مقصد دریافت" : transaction.type === "receive" ? "مقصد دریافت" : "مبدا پرداخت "}
                        info={""}
                    />
                    <div className="flex-col justify-center place-content-center border-b border-black text-center w-full">
                        {returnDestination("شخص", table.destination.rows)}
                        {returnDestination("چک", table.destination.rows)}
                        {returnDestination("تنخواه گردان", table.destination.rows)}
                        {returnDestination("صندوق", table.destination.rows)}
                        {returnDestination("بانک", table.destination.rows)}
                    </div>


                </div>
                <div className="flex  justify-between border-1 border-black p-3 mt-5">
                    <div className="w-1/2 flex gap-2">
                        <span>  مبلغ به حروف :</span>
                        <span> {
                            `${Num2persian(transaction?.amount)} ${transaction?.Currency?.en_title}`
                        }
                        </span>

                    </div>


                    <div className="flex gap-4  p-5">
                        <span className="">{`مبلغ ${typeTitle}:`}</span>
                        <span className="">{`${formatPrice(transaction?.amount)} ${transaction?.Currency?.en_title}`}</span>
                    </div>


                </div>
                <div className="flex  justify-between border-1 border-black p-3">
                    <div className="flex gap-4  p-5">
                        <span className="">امضای ایجاد کننده</span>

                    </div>
                    <div className="flex gap-4  p-5">
                        <span className="">{`امضای ${typeTitle} کننده`}</span>

                    </div>
                </div>

            </div>

            <ReactToPrint
                trigger={() => <div id="toPrintTransAction"></div>}
                content={() => ref.current}
            />
        </div>
    </>);
}

export default PrintTransaction;